<template>
  <div class="comment-con">
    <div v-if="commentList && commentList.length > 0">
      <comment-item v-for="(item, index) in commentList" :key="index" :item="item" :live-title="liveTitle" @handleDownLoad="handleDownLoad"></comment-item>
      <slot></slot>
    </div>
    <div class="no-comment-con" v-else>
      <img src="../../assets/images/no-comment.png" alt="壹心理直播-评论">
      <p>暂无评论</p>
    </div>
  </div>
</template>

<script>
  import commentItem from './commentItem'

  export default {
    name: "Comment",
    components: {
      commentItem
    },
    props: {
      commentList: {
        type: Array,
        default: () => []
      },
      liveTitle: {
        type: String,
        default: ''
      }
    },
    methods: {
      handleDownLoad() {
        this.$emit('handleDownLoad')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .comment-con {
    color: #000;
    padding: 0 30px 60px 30px;
  }

  .no-comment-con {
    margin-top: 327px;
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      width: 330px;
    }

    p {
      margin-top: 30px;
      font-size: 28px;
      color: #6C798C;
      text-align: center;
    }
  }
</style>
